<template>
  <div
    id="background"
    :class="{large: large}"
    :style="{backgroundImage: `url(${require(`@/assets/video/${image}`)})`}"
  >
    <div
      id="play"
      @click="playVideo"
    >
      <img src="@/assets/icons/btn-play@2x.png">
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    image: {
      type: String,
      default: ''
    },
    large: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  mounted: function () {},
  methods: {
    playVideo () {
      this.$emit('playVideo')
    }
  }
}
</script>

<style scoped>
div#background {
  flex: 1 1 30%;
  background-repeat: no-repeat;
  background-size: 100%;
  width: 50%;
  margin: 10px;
  height: 294px;
  position: relative;
  background-size: cover;
  background-position: center;
}

div .large {
  width: calc(100% - 20px) !important;
  height: 370px !important;
}

#text {
  text-align: center;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 7%;
}

#play img {
  width: 92px;
  height: 92px;
  position: absolute;
  top: calc(50% - 46px);
  left: calc(50% - 46px);
}
@media screen and (max-width: 768px) {
  div#background {
    flex: 1 1 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/video-card.vue